// page-products ページのjs
import "../sass/page-products.scss";

import { swiper } from "../jsmodules/_swiper";

document.addEventListener("DOMContentLoaded", () => {
  swiper();
});
